export const initRecaptcha = () => {
    return new Promise((resolve, reject) => {
        if (typeof window.recaptcha !== 'undefined') {
            resolve();
            return;
        }

        var _url = 'https://www.google.com/recaptcha/api.js?render=explicit&hl=' + application.language;
        var recaptcha = document.createElement('script');
        recaptcha.setAttribute('src', _url);
        recaptcha.setAttribute('async', 'async');
        document.head.appendChild(recaptcha);

        recaptcha.onload = function () {
            resolve();
        }
        recaptcha.onerror = function (event) {
            reject(event);
        }
    })
}